import { AppServices } from "@singularsystems/neo-core";
import { ReportingTypes } from "@singularsystems/neo-reporting";
import NeoReportingService from "../NeoReporting/Services/NeoReportingService";


export const AppReportingModule = new AppServices.Module("Reporting", container => {
    // Services
    container.bind(ReportingTypes.Services.ReportingService).to(NeoReportingService).inSingletonScope();
});